import { LeaveRequestApi, ToastStateHandler } from '../../../api';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';

type Callback = (id: string) => void;

const useHttpApproveLeaveRequest = () => {
    const { t } = useTranslation('leaveRequest');
    const leaveRequestApi: LeaveRequestApi = useContainer(LeaveRequestApi);
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);

    const approveLeaveRequest = (id: string, callback: Callback) => {
        const { exec, abort } = leaveRequestApi.approve({
            params: { id },
            onSuccess: () => {
                toastHandler.push(`success`, t('notifications.approveLeaveRequestTitle'), t('notifications.approveLeaveRequestSucceededMessage'));
                callback(id);
            },
            onError: () => {
                toastHandler.push(`error`, t('notifications.approveLeaveRequestTitle'), t('notifications.approveLeaveRequestFailedMessage'));
            },
        });
        exec();
        return abort;
    };

    return { approveLeaveRequest };
};

export default useHttpApproveLeaveRequest;
